<div class="row " style="display: flex;
    text-align: end;
">
    <div class="col col me-3 mt-2" *ngIf="this.logintype !='onboardLogin'">
        <button class="btn btn-sm" type="button" [disabled]="global.viewTabs || global.viewEmployeeTabs" data-bs-toggle="modal"
            data-bs-target="#Generatemodal" (click)="OpenGenerateDynamicForm('generate')">
            Add
        </button>
    </div>
</div>


<div class="row mt-2 ">
    <div class="col-lg-12">
        <ejs-grid #gridDynamicForm  [dataSource]='GridDataList | async' [allowResizing]='true'
            (actionBegin)="onActionComplete($event)" [pageSettings]='initialPage' [filterSettings]='filterOptions'
            [allowFiltering]="true" (dataStateChange)='dataStateChange($event)' [allowPaging]='true'
            (resizeStop)="onResize($event)" [showColumnChooser]='true' [allowSorting]="true">
            <e-columns>
                <!-- Action -->
                <e-column headerText="Actions" minWidth=200 uid='action' textAlign='center' [allowEditing]='false'
                    [allowFiltering]="false" [showInColumnChooser]='false' [allowResizing]='false'>
                    <ng-template #template let-data>
                       
                        <button class="btn btn-edit-table" [disabled]="global.viewTabs || global.viewEmployeeTabs"
                            (click)="checkDownloadType(data);dynamicFormScheduleRefresh(); isAutosave=false;pdfsrc=null"><i
                                class="fa fa-edit"></i></button>
                        <button class="btn btn-delete-table mx-3" data-bs-toggle="modal" [disabled]="global.viewTabs || global.OnboardType=='EMPLOYEE'|| 
                        global.OnboardType=='CLIENT' || global.viewEmployeeTabs" data-bs-target="#deletedoc" (click)="setDynamicId(data)"><i
                                class="fa fa-trash"></i></button>
                        <button class="btn btn-edit-table" [disabled]="global.viewTabs || global.viewEmployeeTabs"
                            (click)="downloadUrl(data.id)"><i class="fa fa-download"></i></button>
                    </ng-template>
                </e-column>
                <!-- Client &  Employee -->
                <e-column minWidth=100 field="clientName" *ngIf="ListCEInputProperty.details.Dynamictype == 'Client'"
                    headerText="Client Name" type="string" [showInColumnChooser]='false'>
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="employeeName"
                    *ngIf="ListCEInputProperty.details.Dynamictype == 'Employee'" headerText="Employee Name"
                    type="string" [showInColumnChooser]='false'>
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <!-- DynamicForm TemplateName -->
                <e-column minWidth=100 field="dynamicFormTemplateName" headerText="DynamicForm TemplateName"
                    type="string" [showInColumnChooser]='false'>
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <!-- CreatedOn -->
                <e-column minWidth=150 field="createdOn" headerText="Create Date" type='date' [format]='formatOptions'
                    [allowFiltering]="false" [allowSorting]="false" [showInColumnChooser]='false'>
                </e-column>
                <e-column minWidth=100 field="dynamicFormGroupName" headerText="Group Name" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                        <div class="d-none d-lg-block">
                            <span id='show' (click)='showDFT()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                </i></span>
                        </div>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>
<!-- View Template -->
<span id="openViewModal" data-bs-target="#viewTemplatemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="viewTemplatemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document"
        style="max-width: 100%; margin: 0; top: 0; bottom: 0; left: 0; right: 0; height: 100vh; display: flex; position: fixed; z-index: 100000;">
        <div class="modal-content">
            <div class="modal-header card-show">
                <div class="col-lg-3">
                    <h5 class="modal-title font-header" id="exampleModalLabel"><span> View
                            Template </span> </h5>
                </div>
                <div class="col-lg-8">
                    <button type="button" class="btn blue-btn btn-sm text_right ml-1 mb-1 " data-bs-dismiss="modal"
                        (click)="destroyInterval()">Close</button>
                    <button type="button" class="btn blue-btn btn-sm text_right ml-1 mb-1 "
                        (click)="updatedynamicForm(false)" [disabled]="isSaveorUpdateBoolean">Update</button>
                    <!-- <button class="btn blue-btn btn-sm text_right ml-1 mb-1 " (click)="downloadPdf()"><span>
                            Download</span>
                    </button> -->
                </div>
            </div>
            <div class="modal-body" *ngIf="pdfsrc!=null && pdfsrc!=undefined && pdfsrc!=''">
                <!-- <pdf-viewer [src]="pdfsrc" [render-text]="true" style="display: block;height:500px"></pdf-viewer> -->
                <ngx-extended-pdf-viewer [src]="pdfsrc" useBrowserLocale="true" ></ngx-extended-pdf-viewer>
            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>
<!-- Delete Template -->
<span id="deletedocument" data-bs-toggle="modal" data-bs-target="#deletedoc"></span>
<div class="modal hide fade modalbackgrod" id="deletedoc" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog  ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
            </div>
            <div class="modal-body ">
                Do you want to delete this record ?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="checkDeleteType()">Yes</button>

                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>